<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :style="{ transform: flip ? 'rotate(180deg)' : '' }" viewBox="0 0 27 27" @click="$emit('click')" class="tw-cursor-pointer">
        <g id="Button_Arrow-Down" transform="translate(0 27) rotate(-90)">
            <g id="Button" transform="translate(27) rotate(90)">
                <g id="Ellipse_1" data-name="Ellipse 1" fill="none" :stroke="stroke" :stroke-width="strokeWidth">
                    <circle cx="13.5" cy="13.5" r="13.5" stroke="none" />
                    <circle cx="13.5" cy="13.5" r="13" fill="none" />
                </g>
                <g id="Group_1257" data-name="Group 1257" :transform="`translate(${translateX} ${translateY}) rotate(${rotate})`">
                    <path id="Path_352" data-name="Path 352" d="M0,0,4.393,4.393,8.786,0" transform="translate(0 0)" fill="none" :stroke="stroke" :stroke-width="strokeWidth" />
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "OutlinedArrows",
    props: {
        width: {
            type: Number,
            default: 27,
        },
        height: {
            type: Number,
            default: 27,
        },
        stroke: {
            type: String,
            default: "#000",
        },
        strokeWidth: {
            type: Number,
            default: 1,
        },
        translateX: {
            type: Number,
            default: 11.588,
        },
        translateY: {
            type: Number,
            default: 17.255,
        },
        rotate: {
            type: Number,
            default: -90,
        },
        flip: {
            type: Boolean,
            default: false
        }
    },
};
</script>
